import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { CSVLink, CSVDownload } from "react-csv";
import { Calendar } from 'primereact/calendar';
import tableRequest from '../../models/tableRequest.js';
import DispatchReportService from '../../services/DispatchReportService';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';
import $ from 'jquery';
import PrintDispatchService from '../../services/PrintDispatchService';
import { Button } from 'primereact/button';

export default class DispatchReport extends Component {
    constructor(props) {
        super(props);
        this.DispatchReportService = new DispatchReportService();
        this.PrintDispatchService = new PrintDispatchService();
        this.tblResponse = new tableRequest();
        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            success: false,
            updateLoader:false,
            visible: false,
            sortOrder:'',
            sales: [],
            loading: true,
            first: 0,
            rows: 10,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            allData: []
        }
        
        this.onPage = this.onPage.bind(this);
        this.FilterData = this.FilterData.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
          this.handlePlantChange = this.handlePlantChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
         this.actionTemplate1 = this.actionTemplate1.bind(this);
        this.onSort = this.onSort.bind(this);
        this.GetReportExport = this.GetReportExport.bind(this);
    }
//to trigger api function o page call
    componentDidMount() {
        setTimeout(() => {
            var date = new Date();
            date.setDate(date.getDate() - 7);
            this.tblResponse.FromDate = date.toLocaleDateString();
            this.tblResponse.ToDate = new Date().toLocaleDateString();
            this.setState({
                FromDate: date,
                ToDate: new Date()
            });
            this.GetDispatch();
            this.GetBillType();
        }, 1000);
        $('.p-column-title').on('click', function(){
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }
//to search data
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetDispatch();
    }

    onChange = date => this.setState({ FromDate: '', ToDate: '' })
  //to export report data
    GetReportExport()
    {
        this.DispatchReportService.GetReportExportDispatch(this.tblResponse).then(data => {
            const resdata = data.data;
            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                  
                this.setState({
                    allData: resdata.ResponseData
                });
                this.setState({ allData: resdata.ResponseData }, () => {
                    this.surveyLink.link.click()
               });
            }  
        });
    }
    //on page loading
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetDispatch();
            this.GetBillType();
        }, 250);
    }

   handlePlantChange(event) {
    const selectedBillType = event.target.value;
    this.tblResponse.BillType = selectedBillType === "0" ? null : selectedBillType;
    this.setState({
        selectedBillType: selectedBillType
    }, () => {
        this.GetDispatch(); // Refresh data when selection changes
    });
}
    // call every change of form and validation part also

    handleChange(event) {
        const { name, value } = event.target;
        //to validate each form field with required conditions
        switch (name) {
            case 'FromDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select from date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("From date must be less than to date.");
                        return;
                    }
                }

                break;
            case 'ToDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select to date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("To date must be greater than from date.");
                        return;
                    }
                }

                break;
            default:
                break;
        }

        this.setState({ [name]: value });
    }

//to filter data
    FilterData() {
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.GetDispatch();
        this.GetBillType();
    }

    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.FromDate = this.state.FromDate;
        this.tblResponse.ToDate = this.state.ToDate;
    }

    GetBillType() {
    this.DispatchReportService.GetBillTypeDDL().then(data => {
        const resdata = data.data;
        if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
            this.setState({
                companyDDL: resdata.ResponseData, // This will be array of objects like [{BillType: "ZSTO"}, ...]
            });
        }
    });
}
    GetDispatch() {
        debugger
        this.tblResponse.SortColumn = 'Id';
         this.tblResponse.BillType = this.state.selectedBillType;
         
        this.DispatchReportService.GetDispatchReport(this.tblResponse).then(data => {
            const resdata = data.data;
            this.setState({updateLoader:true});
            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false
                });
            }
            //if response data null
             else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
        // this.datasource = null;
        // this.setState({
        //     totalRecords: 0,
        //     first: 1,
        //     sales: null,
        //     loading: false
        // });
    }
//for sorting
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetDispatch();
    }

      actionTemplate1(rowData, column) {
        //to print
        const editMode = (e) => {
            this.DispatchReportService.GetDispatchToPrintDetails(rowData).then(data => {
                debugger
                const resdata = data.data;
                debugger
             this.setState({ allData: resdata.ResponseData }, () => {
                    this.surveyLink.link.click()
                });
            
        });

            ////PRINT SLIP
        }
         return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            
        </span>;
    }
    actionTemplate(rowData, column) {
        //to print
        const editMode = (e) => {
            this.DispatchReportService.GetDispatchToPrint(rowData).then(data => {
                debugger
                const resdata = data.data;
                debugger
             this.setState({ allData: resdata.ResponseData }, () => {
                    this.surveyLink.link.click()
                });
            
        });

            ////PRINT SLIP
        }
         return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            
        </span>;
    }
    //to render html part
    render() {

      let header = (
  <div className="d-flex align-items-center justify-content-between flex-nowrap" style={{ gap: '10px', overflowX: 'auto', width: '100%' }}>
    
    {/* Date Filters */}
    <div className="d-flex align-items-center" style={{ gap: '5px' }}>
      <Calendar 
        value={this.state.FromDate} 
        name="FromDate" 
        onChange={this.handleChange} 
        appendTo={document.getElementById('root')} 
        placeholder="From Date" 
      />
      <Calendar 
        value={this.state.ToDate} 
        name="ToDate" 
        onChange={this.handleChange} 
        appendTo={document.getElementById('root')} 
        placeholder="To Date" 
      />
      <button 
        type="button" 
        onClick={this.FilterData} 
        className="btn btn-primary"
      >
        Submit
      </button>
    </div>

    {/* Dropdown (Plant Selector) */}
    <div className="d-flex align-items-center">
    <select 
    id="billType" 
    className="form-control" 
    onChange={this.handlePlantChange} 
    value={this.state.selectedBillType || "0"} 
    style={{ width: '160px' }}
>
    <option value="0">Select Bill Type</option>
    {this.state.companyDDL?.map((item, index) => (
        <option key={index} value={item.BillType}>
            {item.BillType}
        </option>
    ))}
</select>
    </div>

    {/* Search + Export */}
    <div className="d-flex align-items-center" style={{ gap: '5px' }}>
      <i className="pi pi-search" style={{ marginTop: '4px' }}></i>
      <InputText 
        type="search" 
        onInput={this.searchFilter} 
        placeholder="Global Search" 
        size="22" 
      />
      <button 
        className="btn btn-primary export-disabled" 
        target="_blank" 
        disabled={this.state.sales == null} 
        onClick={this.GetReportExport}
      >
        Export
      </button>

      {/* Hidden CSV link */}
      <CSVLink
        hidden={true} 
        data={this.state.allData}
        ref={(r) => this.surveyLink = r}
        filename={"Dispatch report.csv"}
      >
        Export
      </CSVLink>
    </div>
  </div>
);


        return (
            <>
                <MessageComponent ref="Messchild" />
                <Loaders loader={this.state.updateLoader} />
                <div className="heading">
                    <h1>Dispatch Report</h1>
                </div>
                <DataTable exportFilename="Dispatch Report" style={{ width: '100%' }} scrollable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true} className="tblAuto"
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort} ref={(el) => { this.dt = el; }}>
                   <Column field="DispatchId" headerStyle={{ width: '200px' }} header="Dispatch No" sortable={true} />
                   <Column field="DeliveryNo" headerStyle={{ width: '220px' }} header="Delivery No" sortable={true} />
                   <Column field="Plant" headerStyle={{ width: '200px' }} header="Dispatched From" sortable={true} />
                     <Column field="BillType" headerStyle={{ width: '150px' }} header="Bill Type" sortable={true} />
                   <Column field="ShipToParty" headerStyle={{ width: '150px' }} header="Ship To" sortable={true} />
                   <Column field="ShipToPartyName" headerStyle={{ width: '120px' }} header="Ship To Name" sortable="custom" />
                   
                   {/* fromUserName */}
                    <Column field="ObdDate" headerStyle={{ width: '150px' }} header="OBD Date" sortable={true} style={{width:'150px'}} />
                   
                  
                   
                   <Column field="MigoNumber" headerStyle={{ width: '220px' }} header="Migo Number" sortable={false} />
                   <Column field="MigoDate" headerStyle={{ width: '150px' }} header="Migo Date" sortable={true} />
                     <Column field="Status" headerStyle={{ width: '150px' }} header="Status" sortable={true} />
                     
                    <Column field="FromName" headerStyle={{ width: '200px' }} header="Dispatch By" sortable={true} style={{width:'150px'}} />
                    <Column field="CreatedDt" headerStyle={{ width: '150px' }} header="Dispatch Date" sortable={true} />
                   <Column body={this.actionTemplate} headerStyle={{ width: '150px' }} header="Summary Report" />
                     <Column body={this.actionTemplate1} headerStyle={{ width: '150px' }} header="Detail Report" />
                </DataTable>
            </>
        )
    }
}